import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/name/namewyg.png'
import _imports_1 from '@/assets/name.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-35b57e16")

_pushScopeId("data-v-35b57e16")
const _hoisted_1 = { class: "names clearfix" }
const _hoisted_2 = { class: "fl" }
const _hoisted_3 = { class: "fr" }
const _hoisted_4 = {
  key: 0,
  class: "nameimg fl",
  src: _imports_0,
  alt: "",
  srcset: ""
}
const _hoisted_5 = {
  key: 1,
  class: "nameimg fl",
  src: _imports_1,
  alt: "",
  srcset: ""
}
const _hoisted_6 = { class: "nameinfopopup" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "txtline" }, "张启明，中国中医科学院教授，博士研究生导师，学科带头人。国家教育部“新世纪优秀人才”。中国生物医学工程学会中医药工程分会秘书长兼候任主任委员。国家食品药品监督管理总局医疗器械分类技术委员会中医器械专业组组长。", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "txtline" }, "运用数理方法开展中医理论的定量和实证研究。主持国家中医药管理局、国家自然科学基金委、科技部“十一五”国家科技支撑计划、国家科技重大专项课题、科技部“十二五”国家科技支撑计划等科研课题13项。发表学术论文105篇，出版著作5部，获得省部级科研奖励8项。", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "txtline" }, "临床坐诊20余年，治疗晚期恶性肿瘤，常取得减少痛苦、提高生存质量、延长寿命的效果。对小儿癫痫、干燥综合征、过敏性鼻炎、不孕、痛风、湿疹、红斑狼疮、白塞氏综合征等疾病的治疗积累了丰富经验，患者遍及全国各地。", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "txtline" }, "王义国，中国中医科学院副研究员，中国生物医学工程学会中医药工程分会常务委员兼副秘书长。", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "txtline" }, "从事临床科研工作十几年，主要从事中医医疗器械的研发和中医临床疗效评价研究，主持和参与国家级科研课题近10项，发表学术论文50余篇，参编著作4部，获得发明专利授权2项，软件著作权7项。", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "txtline" }, "临床擅长针药结合，治疗阳痿、早泄、遗精、不育等男科疾病；痛经、不孕、更年期综合征等妇科疾病；失眠、头痛、眩晕、肢体麻木等神经系统疾病；胃糜烂、慢性胃炎、胆囊炎、腹泻、便秘等消化系统疾病；高血压、冠心病等心血管疾病；小儿食积、习惯性感冒等儿科疾病；过敏性鼻炎、湿疹等其他杂病。", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createVNode("div", _hoisted_3, [
        (_ctx.person === '王义国')
          ? (_openBlock(), _createBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.person === '张启明')
          ? (_openBlock(), _createBlock("img", _hoisted_5))
          : _createCommentVNode("", true),
        _createVNode(_component_van_icon, {
          name: "info-o",
          class: "nameicon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNameInfo = true))
        })
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showNameInfo,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showNameInfo = $event)),
      round: true,
      closeable: true,
      "close-icon": "clear"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_6, [
          (_ctx.person === '张启明')
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_7,
                _hoisted_8,
                _hoisted_9
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.person === '王义国')
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_10,
                _hoisted_11,
                _hoisted_12
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
})